import { render, staticRenderFns } from "./EstimateAveragePrice.vue?vue&type=template&id=b99849f8&"
import script from "./EstimateAveragePrice.vue?vue&type=script&lang=js&"
export * from "./EstimateAveragePrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports